<template>
  <div class="tablelist"  v-if="viewref">
    <div class="titlePage">Historial Ordenes de Matricula</div>
    <div class="OrderListData">
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :per-page="parseInt(perPage)"
      no-data-label="No se encuentran datos para esta busqueda"
    >
    <div>
    </div>
      <template slot="status" slot-scope="props">
        <div v-if="props.rowData.Sta_Active === false">
            Finalizada
        </div>
        <div v-else-if="props.rowData.Sta_Active === true">
            En proceso
        </div>
        <div v-else>
            Inicializada
        </div>
      </template>
      <template slot="actions" slot-scope="props">
        <div v-for="item of fields[fields.length-1].actionRef" :key="item.id">
          <div v-if="item.action === 'status_user'">
            <div v-if="props.rowData.Sta_Active === true">
              <img src="@/assets/images/DB_Active.png" width="30" title="Activa" alt="Activa" class="ma-0"/>
            </div>
            <div v-else>
              <img src="@/assets/images/DB_Inactive.png" width="30" title="Inactiva" alt="Inactiva" class="ma-0"/>
            </div>
          </div>
        </div>
      </template>
    </va-data-table>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      term: null,
      perPage: '20',
      perPageOptions: ['4', '6', '10', '20'],
      users: [],
      viewref: false,
    }
  },
  props: {
    method: Function,
  },
  computed: {
    fields () {
      return [
        {
          name: 'Id_ParametricHeader',
          title: 'Id',
          width: '10%',
        },
        {
          name: 'Des_ParametricHeader',
          title: 'Detalle',
          width: '30%',
        },
        {
          name: 'Date_ParametricHeader',
          title: 'Fecha Ejecución',
          width: '30%',
        },
        {
          name: '__slot:status',
          title: 'Estado Ejecución',
          width: '30%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Estado',
              icon: 'fa-check',
              action: 'status_user',
            },
          ],
        },
      ]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.users
      }
      return this.users.filter(item => {
        return item.idBanner.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    dataUser (user, ref) {
      this.method(user, ref)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  created: function () {
    // let loader = this.$loading.show()
    var ListHistoryOM = IberoHelpers.getHistoryOM(this.$store)
    ListHistoryOM.then(Response => {
      if (Response.data) {
        this.users = Response.data.HistoryPeriods
        this.viewref = true
      }
      // loader.hide()
    })
  },
}
</script>

<style>
.tablelist .va-button {
  color: #222 !important;
  border-color: #222 !important;
}

/*va-button va-button--outline va-button--normal*/
.tablelist .va-button--active {
  color: #ffffff !important;
  border-color: #222 !important;
  background-color: #222 !important;
}

.tablelist .va-select__label {
  color: #222 !important;
}
.va-select__option--selected {
  color: #222 !important;
}

.tablelist .va-button--small .va-button__content__title {
  color: #222 !important;
}

.va-table th,
.content table th {
  border-bottom: 2px solid #222 !important;
  font-size: 12px !important;
}

.va-data-table__vuetable th.sortable {
  color: #222 !important;
}

.imgdata{
  cursor: pointer;
}

.OrderListData{
  padding: 20px;
}
</style>
